import React from 'react';
import Plotly from 'plotly.js/dist/plotly.min.js';
import {GetParams, MWBaseURL} from './../Utilities.js'
import {createApiClient} from "../api/ApiClient";

class MultiDayGraph extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			acct: null,

			graphIsLoading: props.graphIsLoading
		};

		this.timeseries = []

		this.graphLayout = {
			height: props.height,
			showlegend: false,
			xaxis: {
				rangemode: "tozero"
			},
			yaxis: {
				title: "Net PNL",
				fixedrange: true,
				tickformat: '$,~s'
			},
			legend: {"orientation": "h"},
			margin: {
				b: 50,
				t: 0,
				pad: 0
			}
		}

		this.graphConfig = {
			displaylogo: false,
			scrollZoom: true,
			responsive: true,
			displayModeBar: false
		}
		this.controller = new AbortController()
	}

	static getDerivedStateFromProps(props, state) {
		if(state.acct !== props.acct || state.selectedRows !== props.selectedRows ){
			return {...props, needToUpdate: true}
		}
		return {...props};
	}

	componentDidUpdate(props, state){
		if(this.state.needToUpdate){
			let self = this
			this.setState({needToUpdate: false}, function(){
				self.loadGraph()
			})
		}
	}

	componentDidMount() {
		this.loadGraph()
	}

	componentWillUnmount(){
		this.setState({graphIsLoading: false})
		this.controller.abort();
	}

	getYaxis = (resizeCoord) => {
		if(this.timeseries.length < 1){
			console.log("No timeseries data")
			return resizeCoord;
		}
		let pnlArr = this.timeseries.map(x => x.pnl)
		let minpnl = Math.min(...pnlArr)
		let maxpnl = Math.max(...pnlArr)
		resizeCoord["yaxis.range[0]"] = minpnl - (maxpnl - minpnl) * 0.05
		resizeCoord["yaxis.range[1]"] = maxpnl + (maxpnl - minpnl) * 0.05
		return resizeCoord;
	}

	resizeGraph = (x0, x1) => {
		let self = this
		let resizeCoord = {
			'relayedout': true
		}

		if(!x0 || !x1 || !self.timeseries.length || x0 < self.timeseries[0].timestamp || x1 > self.timeseries[self.timeseries.length - 1].timestamp){
			resizeCoord["xaxis.autorange"] = true
		}

		resizeCoord = self.getYaxis(resizeCoord)
		Plotly.relayout(document.getElementById('graph'), resizeCoord)
	}

	loadGraph = () => {
		let self = this;

		this.controller.abort();
		this.controller = new AbortController()

		self.setState({ graphIsLoading: true })

		const apiClient = createApiClient();
		apiClient.post(MWBaseURL()+'cumulative_trade_timeseries?'+GetParams(this.state), Array.from(self.state.selectedRows, x => ({symbol: x.symbol, start: x.start, end: x.end})), {signal: this.controller.signal})
		.then(data => {
			self.timeseries = data
			self.setState({graphIsLoading: false})

			let graphLines = [{
				name: "Net P&L",
				hovertemplate: '%{y:$,.0f}',
				y: data.map(x => x.pnl),
				x: data.map(x => x.timestamp),
				line: {
					color: (data.length > 0 && data[data.length-1].pnl > 0 ? "#228B22" : "#8B0000")
				}
			}]

			Plotly.newPlot('graph', graphLines, self.graphLayout, this.graphConfig);
			self.resizeGraph()

			document.getElementById('graph').on('plotly_relayout', function(eventdata){
				if('relayedout' in eventdata){
					return;
				}
				
				if("xaxis.range[0]" in eventdata || "xaxis.range[1]" in eventdata){
					self.resizeGraph(eventdata["xaxis.range[0]"], eventdata["xaxis.range[1]"])
				}else{
					self.resizeGraph()
				}

			});
		}).catch(e => console.log(e.message));
	}

	handleGraphRangeReset = () => {
		Plotly.relayout(document.getElementById('graph'), {"xaxis.autorange": true})//will cause relayout to run
	}

	render(){
		return (
			<div style={{height: this.graphLayout.height+"px", position: "relative"}}>
				{this.state.graphIsLoading && 
					(<div id="loading" className="p-4" style={{position: "absolute", width: "100%", zIndex: "20", background: "grey", opacity: "0.2", height: this.graphLayout.height+"px"}}>
						<div className="dotwrapper" style={{opacity: "1"}}>
							<div className="dot0" />
							<div className="dot1" />
							<div className="dot2" />
						</div>
					</div>)
				}
				{(this.state.start || this.state.end) && <button className="btn btn-secondary ml-3 mb-1" onClick={this.handleGraphRangeReset}>Jump to full-day</button>}
				<div id="graph"></div>
			</div>
		)
	}
}
export default MultiDayGraph;